/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Default PDF template for document rendering. Defaults to 'modern' if not set.
 * @nullable
 */
export type EntitySettingsPdfTemplate = typeof EntitySettingsPdfTemplate[keyof typeof EntitySettingsPdfTemplate] | null;


export const EntitySettingsPdfTemplate = {
  modern: 'modern',
  classic: 'classic',
  condensed: 'condensed',
  minimal: 'minimal',
  fashion: 'fashion',
  timeless_modern_full_data: 'timeless_modern_full_data',
} as const;
